module.exports = "<div class=\"aligntop\">\r\n  <icepanelcontainer [settings]=\"inboxSettings\"></icepanelcontainer>\r\n</div>"